// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1xiIe","col":"styles_col__2ra9s"};